import { CollectionFilterValue } from '../../collection/types/collection-filter-value';
import { YYYY_MM_DD_HH_MM_SS } from '../../locale/consts/date-format';
import {
  dateFormat,
  isArray,
  isBoolean,
  isDateRange,
  isNumber,
  isString,
  JsonTypes,
} from '@web/utils';

export const collectionFilterValueSerializer = () => {
  return (value: CollectionFilterValue): JsonTypes => {
    if (isArray(value)) {
      return value;
    }

    if (isBoolean(value)) {
      const TRUE = 1;
      const FALSE = 0;

      return value ? TRUE : FALSE;
    }

    if (isString(value)) {
      return value;
    }

    if (isNumber(value)) {
      return value;
    }

    if (isDateRange(value)) {
      const format = YYYY_MM_DD_HH_MM_SS;

      return [dateFormat(value.from, format), dateFormat(value.to, format)];
    }

    return null;
  };
};
